import { useTranslation } from "@fmc-digital/i18n";
import { SecurityBadgeIcon } from "./icons/SecurityBadgeIcon";

const INFO_SAFE_FALLBACK = "Your information's safe and secure.";

export function SecurityBadge() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 justify-center text-on-surface-variant">
      <SecurityBadgeIcon />
      <span className="text-[13px] font-normal leading-[20px] text-on-surface-variant">
        {t("auth.register.infoSafe", { defaultValue: INFO_SAFE_FALLBACK })}
      </span>
    </div>
  );
}
